import styled from 'styled-components';

import { px, fontFamilySize, colors } from '../../../../contrib/ui';

export const WinnerSelectorStyled = styled.div`
  margin-bottom: ${px(30)};

  p.title {
    ${fontFamilySize()}
    color: ${colors.grey9b};
  }

  button {
    padding-right: 0;
    span {
      color: ${colors.grey87};

      svg {
        font-size: ${px(45)};
        margin-left: 0;
      }
    }
  }
`;
